
































import Vue from "vue"
import Component from "vue-class-component"
import firebase from "firebase/app"
import "firebase/auth"

@Component({ name: "UserProfile" })
export default class UserProfile extends Vue {
  public hasImage = false

  get avatar() {
    const user = firebase.auth().currentUser
    return user ? user.photoURL : ""
  }

  logout() {
    var self = this
    firebase
      .auth()
      .signOut()
      .then(() => {
        this.$router.push("/login")
      })
  }
}
